import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Box, useMediaQuery } from '@mui/material';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTheme } from '@emotion/react';
import RoomBooking from './RoomBooking';

// export default function TravelGroup() {
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const isSmallScreen=useMediaQuery('sm')
//   const theme=useTheme()
//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const open = Boolean(anchorEl);
//   const id = open ? 'simple-popover' : undefined;
//   const arr=['Room','Adult','Child','Baby']

//   return (
//     <div >
//       <Box aria-describedby={id} sx={{
//         borderRight:"2px solid #D6DAC8",
//         width:isSmallScreen ? "100%" :" 200px",
//         p:1,
//         cursor:'pointer',
//         display:"flex",
//         justifyContent:"space-between",
//         alignItems:"center"
//       }} variant="contained" onClick={handleClick}>
//         <Box>
//         <Typography sx={{fontSize:"10px"}}> Travel group</Typography>
//        <Typography sx={{fontSize:"1rem",fontWeight:"medium"}}>2 Adults 1 room</Typography>
//         </Box>
//         <Box>
//         <KeyboardArrowDownIcon sx={{ color: theme?.palette?.widget?.Dropdown?.textColor, mr: 2 }}
//  />        </Box>
    
//       </Box>
//       <Popover
//         id={id}
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{
//           vertical: 'bottom',
//           horizontal: 'left',
//         }}
//       >
//       <RoomBooking />
//       </Popover>
//     </div>
//   );
// }


export default function TravelGroup() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const theme = useTheme();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Box
        aria-describedby={id}
        onClick={handleClick}
        sx={{
          width: isSmallScreen ? "100%" : "220px",
          p: 1.5,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          border: isSmallScreen ? "1px solid #E5E7EB" : "1px solid #D6DAC8",
          transition: "0.2s ease-in-out",
          "&:hover": {
            boxShadow: "0px 3px 8px rgba(0,0,0,0.08)",
          },
        }}
      >
        {/* LEFT COLUMN */}
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            sx={{
              fontSize: "11px",
              color: "#6B7280",
              fontWeight: 500,
              letterSpacing: 0.3,
            }}
          >
            TRAVEL GROUP
          </Typography>

          <Typography
            sx={{
              fontSize: "1rem",
              fontWeight: 600,
              mt: 0.3,
              color: "#111827",
            }}
          >
            2 Adults · 1 Room
          </Typography>
        </Box>

        {/* DROPDOWN ICON */}
        <KeyboardArrowDownIcon
          sx={{
            color: theme?.palette?.widget?.Dropdown?.textColor || "#374151",
            fontSize: isSmallScreen ? "1.4rem" : "1.8rem",
          }}
        />
      </Box>

      {/* POPOVER */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            p: 2,
            boxShadow: "0px 4px 12px rgba(0,0,0,0.12)",
          },
        }}
      >
        <RoomBooking />
      </Popover>
    </div>
  );
}



